import { EditProfileFormSectionKeys } from "../../EditProfileForm/const";

/**
 * Returns the accordion event key of the Edit Profile Form for the given pickup field.
 * If editing this pickup field is not implemented yet, returns undefined.
 * Should be expanded upon as more sections are added to the Edit Profile Form.
 * @param key - The key of the pickup field
 * @returns The accordion event key of the Edit Profile Form for this section
 */
export const getAccordionEventKey = (
  key: string
): EditProfileFormSectionKeys | undefined => {
  switch (key) {
    case "has_profile_description":
      return EditProfileFormSectionKeys.DESCRIPTION;
    case "has_regular_hours_periods":
      return EditProfileFormSectionKeys.REGULAR_HOURS;
    default:
      // This section has not been implemented yet
      return undefined;
  }
};
